// extracted by mini-css-extract-plugin
export var back = "languageSelect-module--back--fRIjc";
export var dropdown = "languageSelect-module--dropdown--MxCT0";
export var flag = "languageSelect-module--flag--KHJMH";
export var link = "languageSelect-module--link--Rmz+T";
export var root = "languageSelect-module--root--BI-TT";